import { api } from 'API'
import { getError } from 'utils/getError'

// SSO Configuration API Functions
// TODO: move to a proper types file
export interface SSOConfig {
  id?: number
  provider: string
  enabled?: boolean
  config: any
  organizationId?: number
  emailBindCutoffDate?: string
}

export async function getSSOConfigs(): Promise<SSOConfig[]> {
  try {
    const response = await api.get('/sso-configs')
    return response.data
  } catch (error) {
    throw new Error(getError(error))
  }
}

export async function createSSOConfig(ssoConfigs: Omit<SSOConfig, 'id'>[]): Promise<SSOConfig[]> {
  try {
    const response = await api.post('/sso-configs', ssoConfigs)
    return response.data
  } catch (error) {
    throw new Error(getError(error))
  }
}

export async function updateSSOConfig(id: number, ssoConfig: Partial<SSOConfig>): Promise<void> {
  try {
    await api.patch(`/sso-configs/${id}`, ssoConfig)
  } catch (error) {
    throw new Error(getError(error))
  }
}

export async function deleteSSOConfigs(): Promise<void> {
  try {
    await api.delete('/sso-configs/organization')
  } catch (error) {
    throw new Error(getError(error))
  }
}

export interface TestConnectionResult {
  success: boolean
  message: string
  details?: any
}

export async function testSSOConnection(id: number): Promise<TestConnectionResult> {
  try {
    const response = await api.post(`/sso-configs/${id}/test-connection`)
    return response.data
  } catch (error) {
    throw new Error(getError(error))
  }
}
